import type { GriffelStyle } from '@fluentui/react-components'
import { tokens } from '@fluentui/react-components'

// the sum of spacing between the table and bubble edges + bubble to the taskpane edge
const tableFullWidthOffset = `calc(${tokens.spacingVerticalS} + ${tokens.spacingVerticalL})`

export const tableStyles: GriffelStyle = {
  '& .chat-table-breakout': {
    margin: `${tokens.spacingVerticalS} calc(${tableFullWidthOffset} * -1)`,
  },
  '& .chat-table-scroll': {
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingLeft: tableFullWidthOffset,
    paddingRight: tableFullWidthOffset,
    boxSizing: 'border-box',
  },
  '& .chat-table-scroll > table': {
    width: 'max-content',
    maxWidth: 'none',
    marginBottom: 0,
    marginRight: tokens.spacingVerticalXL,
  },
  '& .chat-table-scroll > table td, & .chat-table-scroll > table th': {
    minWidth: '120px',
  },
  '& .chat-table-scroll table, & .chat-table-scroll th, & .chat-table-scroll td, & .chat-table-scroll caption, & .chat-table-scroll p, & .chat-table-scroll span':
    {
      wordBreak: 'normal',
      overflowWrap: 'normal',
    },
}
